import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu, X, LogOut, Shield } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const memberLinks = [
    { to: "/dashboard", label: "Dashboard" },
    { to: "/browse", label: "Browse" },
    { to: "/search", label: "Search" },
    { to: "/matches", label: "Matches" },
    { to: "/favorites", label: "Favorites" },
    { to: "/messages", label: "Messages" },
  ];
  const publicLinks = [
    { to: "/about", label: "About" },
    { to: "/pricing", label: "Pricing" },
    { to: "/comparison", label: "Comparison" },
    { to: "/contact", label: "Contact" },
  ];
  const links = user ? memberLinks : publicLinks;

  const handleLogout = async () => { await logout(); navigate("/"); };

  return (
    <nav className="sticky top-0 z-50 glass border-b border-stone-100">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-24">
        <Link to={user ? "/dashboard" : "/"} data-testid="nav-logo" className="flex items-center group">
          <img src="/logo.png" alt="qrcupid" className="h-20 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-colors ${loc.pathname === l.to ? "bg-[#F3E8E6] text-[#8B1E3F]" : "text-stone-600 hover:text-stone-900"}`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin" className="px-4 py-2 text-sm font-medium rounded-full bg-stone-900 text-white hover:bg-black transition-colors flex items-center gap-1.5">
                  <Shield className="w-4 h-4" /> Admin
                </Link>
              )}
              <Link to="/profile" data-testid="nav-profile" className="px-4 py-2 text-sm font-medium rounded-full text-stone-700 hover:bg-stone-100 transition-colors">My Profile</Link>
              <button onClick={handleLogout} data-testid="nav-logout" className="p-2.5 rounded-full text-stone-500 hover:bg-stone-100 hover:text-stone-900 transition-colors">
                <LogOut className="w-[18px] h-[18px]" />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="px-5 py-2 text-sm font-medium rounded-full text-stone-700 hover:bg-stone-100 transition-colors">Log in</Link>
              <Link to="/register" data-testid="nav-register" className="px-5 py-2.5 text-sm font-medium rounded-full bg-[#8B1E3F] text-white hover:bg-[#701530] transition-colors shadow-sm">Join free</Link>
            </>
          )}
        </div>

        <button className="md:hidden p-2 rounded-lg text-stone-700" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-stone-100 px-5 py-3 space-y-1">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block px-3 py-2.5 text-sm font-medium text-stone-700 rounded-lg hover:bg-stone-100">{l.label}</Link>
          ))}
          <div className="h-px bg-stone-100 my-2" />
          {user ? (
            <>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="block px-3 py-2.5 text-sm font-medium text-stone-700">Admin</Link>}
              <Link to="/profile" onClick={() => setOpen(false)} className="block px-3 py-2.5 text-sm font-medium text-stone-700">My Profile</Link>
              <button onClick={() => { setOpen(false); handleLogout(); }} className="block w-full text-left px-3 py-2.5 text-sm font-medium text-stone-700">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="block px-3 py-2.5 text-sm font-medium text-stone-700">Log in</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="block px-3 py-2.5 text-sm font-medium text-[#8B1E3F]">Join free</Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
